<template>
  <div class="sky-caseRepo-link">
    <el-input v-model="value" :disabled="disabled"></el-input>
    <el-popover placement="right" class="el-form-item__tip sky-custom-description__popover el-popover__reference">
      <div>
        <div class="item-value">
          <a class="sk-link--text el-icon-download" @click="openUrl()"> 测试用例批量导入模版下载 </a><br />
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script type="text/babel">
import { Button, Popover } from 'element-ui'

import { CASE_REPO } from '@/api/apiModules'

export default {
  name: 'SkyCaseRepoLink',
  inject: ['rootView', 'elForm'],
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover
  },
  props: {
    value: {
      type: [String, Array],
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  methods: {
    openUrl() {
      this.$store.dispatch('customDownloadDocument', {
        module: CASE_REPO,
        params: {
          id: new Date().getTime()
        },
        action: 'downloadTemplate'
      })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(caseRepo-link) {
  & .el-popper {
    position: relative;
    color: blue;
    display: inline-block !important;
    border: none !important;
    border-radius: none !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
  }
}
</style>
